import React, { useRef, useState, useEffect } from "react";
import "../../Style.scss";
import "../../responsive.scss";
import logo from "../../Assets/images/logo/logo.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import Transition from "../Transition";

const Navbar2 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  const location = useLocation();

  const about = useRef(null);
  const service = useRef(null);
  const media = useRef(null);

  const isAboutActive = [
    "/Introduction",
    "/QualityExpertise",
    "/PersonalizedCare",
    "/AdvancedTechnology",
    "/AffordableTreatment",
    "/RightEnvironment",
  ].includes(location.pathname);

  // const isProgrammeActive = [
  //   "/Programme/ICSI",
  //   "/Programme/PRP",
  //   "/Programme/IUI",
  //   "/Programme/EmbryoTransfer",
  //   "/Programme/AssistedHeching",
  //   "/Programme/PGS",
  //   "/Programme/MACS",
  //   "/Programme/GamateDonars",
  //   "/Programme/SemenCryopreservation",
  //   "/Programme/EmbryoCryopreservation",
  //   "/Programme/ForeignPatientCare",
  //   "/Programme/SingleEmbryoTransfer",
  //   "/Programme/LaserAssistedHatching",
  //   "/Programme/OocyteFreezing",
  //   "/Programme/PICSI",
  // ].includes(location.pathname);

  const isServiceActive = [
    "/LaparoscopyHysteroscopy",
    "/WomenHealthCare",
    "/FertilityCounselling",
    "/HormonalAssays",
    "/FollicularMonitoring",
    "/MaleInfertility",
    "/ObstetricCare",
    "/UrinaryIncontinenceManagement",
  ].includes(location.pathname);

  const isMediaActive = ["/Blogs", "/FAQ"].includes(location.pathname);

  useEffect(() => {
    if (about.current)
      about.current.style.color = isAboutActive ? "#05BB8F" : "black";
    if (service.current)
      service.current.style.color = isServiceActive ? "#05BB8F" : "black";
    if (media.current)
      media.current.style.color = isMediaActive ? "#05BB8F" : "black";
  }, [location.pathname, isAboutActive, isServiceActive, isMediaActive]);

  return (
    <header>
      <div className="container-fluid">
        <nav>
          <Link to="/" className="navbar-brand">
            <img src={logo} className="main-logo" alt="logo" />
          </Link>

          <div className={isOpen ? "nav-linkss active" : "nav-linkss"}>
            <ul className="navbar-nav">
              <li className="nav-item" onClick={toggleMenu}>
                <NavLink to="/" className="nav-link">
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <Link ref={about} className="nav-link dropdown-toggle">
                  About
                </Link>
                <ul className="dropdown-menu">
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/Introduction" className="nav-link">
                      Introduction
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/QualityExpertise" className="nav-link">
                      Quality Expertise
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/PersonalizedCare" className="nav-link">
                      Personalised Care
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/AdvancedTechnology" className="nav-link">
                      Advanced Technology
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <Link to="/AffordableTreatment" className="nav-link">
                      Affordable Treatments
                    </Link>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <Link to="/RightEnvironment" className="nav-link">
                      Right Environment
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item" onClick={toggleMenu}>
                <NavLink to="/Programme/IVF" className="nav-link">
                  Programme
                </NavLink>
              </li>

              <li className="nav-item">
                <Link ref={service} className="nav-link dropdown-toggle">
                  Services
                </Link>
                <ul className="dropdown-menu">
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/LaparoscopyHysteroscopy" className="nav-link">
                      Laparoscopy & Hysteroscopy
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/WomenHealthCare" className="nav-link">
                      Women Health Care
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/FertilityCounselling" className="nav-link">
                      Fertility Counselling
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/HormonalAssays" className="nav-link">
                      Hormonal Assays
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/FollicularMonitoring" className="nav-link">
                      Follicular Monitoring
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/MaleInfertility" className="nav-link">
                      Male Infertility
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/ObstetricCare" className="nav-link">
                      Obstetric Care
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink
                      to="/UrinaryIncontinenceManagement"
                      className="nav-link"
                    >
                      Urinary Incontinence Management
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item" onClick={toggleMenu}>
                <NavLink to="/Doctor" className="nav-link">
                  Doctors
                </NavLink>
              </li>

              <li className="nav-item">
                <Link ref={media} className="nav-link dropdown-toggle">
                  Media
                </Link>
                <ul className="dropdown-menu">
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/Blogs" className="nav-link">
                      Blogs
                    </NavLink>
                  </li>
                  <li className="nav-item" onClick={toggleMenu}>
                    <NavLink to="/FAQ" className="nav-link">
                      FAQ
                    </NavLink>
                  </li>
                </ul>
              </li>
            </ul>

            <div className="others-options ms-5 MYms-1">
              <Link to="/Contact" className="common-btn style1" onClick={toggleMenu}>
                Contact <span><i className="bx bx-plus"></i></span>
              </Link>
            </div>
          </div>

          <div className="MenuIcon" onClick={toggleMenu}>
            <i className="bx bx-menu-alt-right"></i>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Transition(Navbar2);
